// extracted by mini-css-extract-plugin
export default {"container":"OrgMembersTable_container__1i1Dq","table":"OrgMembersTable_table__Q43Yc","action":"OrgMembersTable_action__wFwd-"};